"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _styles = require("../styles");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Users = function Users(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor,
    _ref$animation = _ref.animation,
    animation = _ref$animation === void 0 ? '' : _ref$animation;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/React.createElement(_styles.Svg, {
    className: "".concat(className, " ").concat(animation),
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.525 10.496c.5-.428.82-1.052.82-1.76a2.33 2.33 0 00-2.328-2.328 2.33 2.33 0 00-2.328 2.328c0 .708.324 1.336.824 1.764a3.458 3.458 0 00-.396.168 4.918 4.918 0 00-1.788-1.08 2.581 2.581 0 001.004-2.036c0-1.432-1.168-2.6-2.6-2.6a2.605 2.605 0 00-2.6 2.6c0 .828.396 1.56 1.004 2.036a4.944 4.944 0 00-3.344 4.668.46.46 0 00.92 0 4.021 4.021 0 014.016-4.016 4.024 4.024 0 014.016 4.016.46.46 0 00.92 0 4.895 4.895 0 00-.924-2.864c.404-.16.836-.248 1.272-.248a3.455 3.455 0 013.452 3.452.46.46 0 00.92 0 4.365 4.365 0 00-2.86-4.1zM7.733 5.868a1.68 1.68 0 110 3.36 1.68 1.68 0 010-3.36zm5.284 1.456a1.41 1.41 0 010 2.82 1.41 1.41 0 010-2.82z",
    fill: color
  }));
};
var _default = exports["default"] = Users;